var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlison(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 452.77 603.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .eyes{display:none;}.cls-alison-1{fill:none;}.cls-alison-2{fill:#060409;}.cls-alison-3{fill:#543a34;}.cls-alison-4{fill:#f2a692;}.cls-alison-5{fill:#736e5b;}.cls-alison-6{fill:#b4a880;}.cls-alison-10,.cls-alison-7{fill:#6d3f39;}.cls-alison-7{opacity:0.2;}.cls-alison-8{fill:#62261a;}.cls-alison-9{clip-path:url(#clip-alison-path);}.cls-alison-10{opacity:0.15;}.cls-alison-11{fill:#ffddce;}.cls-alison-12{fill:#a45f65;}.cls-alison-13{fill:#803d41;}.cls-alison-14{fill:#fff;}.cls-alison-15{fill:#070707;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-alison-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-1",
    d: "M330.5,191.78s-23.51,3.55-38.91.4-39.7-5-39.7-5-2.24-6.52,2.82-8.88,34.18,1.8,35.41-1.91-9.87-17.87-18.44-20.44c0,0-11.86-6.14-31.11-2.8l2.58-11.52s8.33-3.48,14.4-1.82,23,2.88,23,2.88,22.11-14.29,36.52-9.39C352.61,145.41,330.5,191.78,330.5,191.78Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-2",
    d: "M73.06,444.79c21.91-40.88,181.78-17.23,205.33,6.49C299.63,472.67,383,618.34,383,618.34l-334.58-.91S51.15,485.66,73.06,444.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-3",
    d: "M98.35,144.39s-17.95,54.76-38.7,80.3l30.92-5.19S104.94,154.06,98.35,144.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-3",
    d: "M100.7,100.35s-2.53,17.1-9.59,26.85-17.78,30.69-9,61.62c0,0,1.36-25.9,6.82-33.13,8.24-10.9,18.76-16.8,18.76-20.21S100.7,100.35,100.7,100.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-4",
    d: "M82.71,218.29s-27.85-1.17-45.55,19.14S-11.7,321.81,4.55,416.49c0,0,5.29,12.17,4.92,19.9s1.59,12.05,8.81,16.81,78.12-31.95,59.3-39.49C77.58,413.71,89.62,238.47,82.71,218.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-4",
    d: "M255.87,200.07s30-2.19,49.64,10.4,60,41.65,60,41.65a33.43,33.43,0,0,0-6.66-20c-7.22-9.63-28.32-40.35-28.32-40.35s-23.51,3.55-38.91.4-39.7-5-39.7-5-2.24-6.52,2.82-8.88,34.18,1.8,35.41-1.91-9.87-17.87-18.44-20.44c0,0-11.86-6.14-31.11-2.8l2.58-11.52s8.33-3.48,14.4-1.82,23,2.88,23,2.88,21.82-13.33,36.52-9.39,26.33,27.8,43,36.08l11.56,13.65s68.25,70.24,79.66,117.75a17.71,17.71,0,0,1-3.22,15.38,15.19,15.19,0,0,1-12,5.69c-13.55.25-97.31-7.69-132.57-30.78a4,4,0,0,0-6.14,2.73,165.38,165.38,0,0,0-2.11,23.23S239.05,318.21,255.87,200.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-5",
    d: "M243.44,199.5l12.43.57s27.45,54.24,40.27,100.28c2,7.23,5.31,53.24-9.84,76.09-12.79,19.28-7.55,74.35-8.32,74.11C208.4,428.41,72.6,445.76,72.6,445.76s.14-67.53-1.72-84.82C65.26,308.35,82,243.14,82,243.14S202.69,196.76,243.44,199.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-6",
    d: "M182.57,267.43a7.73,7.73,0,1,0,7.73,7.73A7.74,7.74,0,0,0,182.57,267.43Zm0,12.83a5.36,5.36,0,1,1,5.35-5.36A5.36,5.36,0,0,1,182.57,280.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-alison-6",
    points: "181.17 268.42 206.46 208.4 206 210.44 182.86 268.77 179.66 269.6 145.06 221.51 145.85 221.51 181.17 268.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-7",
    d: "M365.48,252.12s1.74,11.55,3.18,18.76c1,4.87,7.45,28.09,23.22,35.84,0,0-34.52-8.72-33.78-60.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-3",
    d: "M239.32,152.53s8.44,12.36,6.19,28.29-8.33,39.52,17.9,44.39c0,0-12.85,22.86-36.83,3.38,0,0-17.77,9.44-22.47-15.14S226,155,239.32,152.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-3",
    d: "M176.2,3.3s41.82-12,59.08,15.5S231.48,65,231.48,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-4",
    d: "M193.59,20.31S208.2,18.7,220.08,38.1s14.85,29.7,14.85,29.7l9.31,27.13s3.73,11.6,2.73,32.29-4.53,47.74-28.83,49.69l-14,36.54s-23.76,22.5-60.2,7.93l-29.15-41.65,2.78-74.62L157.8,32.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-3",
    d: "M194.15,34.8a4.77,4.77,0,0,1-4.91,2.7c-5.57-.71-17.7-1-27.33,7.57-12.94,11.53-.8,44.4-15.27,60.67s-25.31,17.72-23.14,30.38,16.17,18.55,19.92,16.55,4-4.89,4-4.89,1.49,18.12,4.44,23.9,2.16,17.4-9.85,27.69,10.19,22.39,11.18,40.72c1,18.49-14.49,40-39.42,34.5,0,0,11-5.82,12.93-16,0,0-12.49,1.66-17.78-1.46s-21.15,12.74-26.67-4.33-3.67-35.22,3.59-45.1,18.57-83.26,14.26-112.88S94.44,38,124.33,15.9,170.91,1.09,180.61,1.36c6.2.17,11.63,5.66,14.26,12.94A27,27,0,0,1,194.15,34.8Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-alison-8",
    cx: 141.52,
    cy: 147.56,
    r: 2.43
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-alison-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-10",
    d: "M309.41,142.86s17.71,13.44,21.58,24c5.65,15.45-17.72,29.7-33.59,30.39s-41.53,2.77-41.53,2.77l-19-22.17S293.26,142.47,309.41,142.86Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-7",
    d: "M158.55,151.78s21,22.15,59.59,25.13l-7.58,19.73S167.69,185.29,158.55,151.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-4",
    d: "M280.58,142.74s-13.56,14.86-13.9,19c-.27,3.32,7.53,18,10.62,23.69a1.94,1.94,0,0,0,3.23.26,8.62,8.62,0,0,0,1.68-8.53c-2.23-6.26-6.14-13.74-3.57-18.1l2.56-4.36s-2.56,7.6,1.12,11.51,14.3,13.29,17.88,12.85,3.35-3.8,1.56-6.82-9.27-10.17-9.27-10.17l-.45-10.5,5.81,13.07,11.49,6.31a1.78,1.78,0,0,0,2.63-1.38c.22-2.51-.2-6.23-4.06-8.07-2.2-1,.11-11.49.11-11.49a14,14,0,0,1,8.48-3.62c5.69-.59,14.16,15.09,27.77,10.27,0,0-9.32-13.21-14.06-16.26S314,122.19,280.58,142.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-11",
    d: "M333.35,196.53c2.68-4.19,15.34-23.2,26.78-27.1,0,0,.91-2.64,4.61-1.78S376,179.53,376,181.06a40.46,40.46,0,0,1-.76,5.22l-4.56-4.65s-17.17,14.09-26.91,28.25a1.43,1.43,0,0,1-2.32-.1l-8-11.64A1.45,1.45,0,0,1,333.35,196.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-4",
    d: "M4.55,416.49s5.29,12.17,4.92,19.9,1.59,12.05,8.81,16.81S130.71,590.7,153.39,611.83s71.44,37.42,11.06-73.49c-28.13-51.64-73.4-117.62-92.22-125.15C72.23,413.19-11.7,321.81,4.55,416.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-12",
    d: "M208.08,145.33s14.66,6.9,23.33,3c8.37-3.76,8.49-12.92,8.26-15.86a.22.22,0,0,0-.3-.18l-14.88,6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-alison-13",
    d: "M208.08,145.33s14.81-12.25,18.91-12.25,4.42-.79,6.36-2.35c.74-.59,4,0,5.64.59,1,.4.63,1,0,1.92a24.18,24.18,0,0,1-8.33,6.61c-5.77,2.84-9.6,2.67-12.67,3.69A28.62,28.62,0,0,1,208.08,145.33Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    className: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-alison-14 eyeball",
    cx: 225.91,
    cy: 79.54,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-alison-15 pupil",
    cx: 225.91,
    cy: 79.54,
    r: 7.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-alison-14 eyeball",
    cx: 187.29,
    cy: 94.45,
    r: 11.42
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-alison-15 pupil",
    cx: 187.29,
    cy: 94.45,
    r: 7.48
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlison);
export default __webpack_public_path__ + "static/media/Alison.d62669ae0c36641f0a16c55a2262c206.svg";
export { ForwardRef as ReactComponent };